import './style/index.js';

import _RangeInput from './RangeInput.jsx';
import _RangeInputPopup from './RangeInputPopup';

export type { RangeInputProps } from './RangeInput.jsx';
export * from './type';

export const RangeInput = _RangeInput;
export const RangeInputPopup = _RangeInputPopup;
export default RangeInput;
